// extracted by mini-css-extract-plugin
export default {"largeTitleStyle":"ModuleTitle_largeTitleStyle__Ol6cd","middleTitleStyle":"ModuleTitle_middleTitleStyle__UCa6O"};